export default __webpack_public_path__ + "static/media/consolas.0e8d213e.jpg";